export const STORAGE_KEYS = {
	ADMIN_PANEL_TYPE: "admin_panel_type",
};
